var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.studentProfile
        ? _c(
            "back-profile",
            {
              nativeOn: {
                click: function($event) {
                  return _vm.navigateTo("app.profile.home")
                }
              }
            },
            [_vm._v("Perfil de " + _vm._s(_vm.studentProfile.student.name))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "block",
        [
          _c("template", { slot: "header" }, [
            _vm._v("Atenciones (" + _vm._s(this.studentAttentions.length) + ")")
          ]),
          _vm._v(" "),
          _c("template", { slot: "actions" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary is-outlined",
                on: {
                  click: function($event) {
                    return _vm.navigateTo("app.profile.add_attention")
                  }
                }
              },
              [_vm._v("\n        + Agregar\n      ")]
            )
          ]),
          _vm._v(" "),
          _c("alert-item-list", {
            attrs: {
              items: this.orderedGroupOfAttentions(
                _vm.studentGroupOfAttentions
              ),
              "key-field": "id"
            },
            on: { "item-selected": _vm.goToAttention },
            scopedSlots: _vm._u([
              {
                key: "icon",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    item.status == "PENDING"
                      ? _c("span", [
                          _c("img", {
                            staticClass: "icon icon-svg",
                            attrs: {
                              src: require("@/static/svg/icono_pendiente_v2.svg"),
                              alt: "pendiente"
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.status == "COMPLETED"
                      ? _c("span", [
                          _c("img", {
                            staticClass: "icon icon-svg",
                            attrs: {
                              src: require("@/static/svg/icono_check_v2.svg"),
                              alt: "completado"
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    item.status == "FAILED"
                      ? _c("span", [
                          _c("img", {
                            staticClass: "icon icon-svg",
                            attrs: {
                              src: require("@/static/svg/icono_nocheck_v2.svg"),
                              alt: "fallido"
                            }
                          })
                        ])
                      : _vm._e()
                  ]
                }
              },
              {
                key: "title",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _vm._v(
                      _vm._s(item.title) +
                        " (" +
                        _vm._s(item.finished) +
                        "/" +
                        _vm._s(item.total) +
                        ")"
                    )
                  ]
                }
              },
              {
                key: "description",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.formatAttentionDate(item)))])
                  ]
                }
              }
            ])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }